import { render, staticRenderFns } from "./WsataUnderReports.vue?vue&type=template&id=caa0fece&"
import script from "./WsataUnderReports.vue?vue&type=script&lang=js&"
export * from "./WsataUnderReports.vue?vue&type=script&lang=js&"
import style0 from "./WsataUnderReports.vue?vue&type=style&index=0&id=caa0fece&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports